export default __webpack_public_path__ + "static/wendy-legacy-campaign-420837766c92d67225e0fe0032803c59.jpg";